import { render, staticRenderFns } from "./ConsultaDps.vue?vue&type=template&id=103c8039&scoped=true&"
import script from "./ConsultaDps.vue?vue&type=script&lang=js&"
export * from "./ConsultaDps.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaDps.vue?vue&type=style&index=0&id=103c8039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c8039",
  null
  
)

export default component.exports